/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { GridProps, GridRef } from "./types";

export default CustomPlatform.select<
  () => React.ForwardRefExoticComponent<
    GridProps & React.RefAttributes<GridRef>
  >
>({
  web: () => require("./Grid.web").default,
  default: () => require("./Grid").default,
})();
